
import React        from 'react';
import ClassBar     from './ClassBar';

class SearchResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      certifiedSearchId: '',
      certifiedResults: [],
      ugcSearchId: '',
      ugcResults: []
    }
  }

  componentDidMount() {
    const iAmUsingTheDangerousDevelopmentVersion = false;
    if (iAmUsingTheDangerousDevelopmentVersion) {
      // DEVELOPMENT CODE - relies on server to proxy prod data:
      this.stubSearchResults(this.props.q, this.props.op);
    } else {
      // PRODUCTION CODE:
      this.fetchSearchResults(this.props.q, this.props.op);
    }
  }

  render() {
    return (
      <div>
        <ul className="market-search-results market certified">
          {this.renderCertifiedClassBars()}
        </ul>

        <ul className="market-search-results ugs ugc">
          {this.renderUgcClassBars()}
        </ul>
      </div>
    );
  }

  renderCertifiedClassBars() {
    if (this.state.certifiedResults.length < 1) {
      return null;
    }

    let self = this;

    return this.state.certifiedResults.map(function(result, i) {
      return (
        <ClassBar
          key={i}
          searchId={self.state.certifiedSearchId}
          classData={result._source}
          classType='certified'
        />
      );
    });
  }

  renderUgcClassBars() {
    if (this.state.ugcResults.length < 1) {
      return null;
    }

    let self = this;

    return this.state.ugcResults.map(function(result, i) {
      return (
        <ClassBar
          key={i}
          searchId={self.state.ugcSearchId}
          classData={result._source}
          classType='ugc'
        />
      );
    });
  }

  fetchSearchResults(q, op, stub=false) {
    var self = this;

    var data = {
      "api_v1_search_result": {
        "indexes": [ "market", "ugs" ],
        "q": q,
        "operator": op,
        "page": 1,
        "trim_results": true,
      },
      "format": "json"
    }

    if (stub) { data.api_v1_search_result.stub = true }

    $.get("/api/search", data)
    .done(function(data) {
      self.setState({
        certifiedSearchId: data.market_results.market_search_id,
        certifiedResults: data.market_results.hits,
        ugcSearchId: data.ugs_results.ugs_search_id,
        ugcResults: data.ugs_results.hits
      });
    });
  }

  stubSearchResults(q, op) {
    console.log(`USING code-pollution-free STUB Search (if it doesn't work, run "sudo <editor> /etc/hosts" and add "0.0.0.0<tab>localhost.brainscape.com" then visit: "http://localhost.brainscape.com:3000/learn/search?q=...") q: ${q}, op: ${op}`);
    this.fetchSearchResults(q, op, true)
  }
};

export default SearchResults;
